class SwEmAcaoFilters extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
    this.cards = Array.from(document.querySelectorAll('[data-em-acao-card]'));
    this.emptyState = document.querySelector('[data-em-acao-empty]');

    if (!this.buttons.length || !this.cards.length) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.applyFilter(button));
    });
  }

  applyFilter(activeButton) {
    const filter = activeButton.dataset.filter;

    this.buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    let visibleCount = 0;

    this.cards.forEach((card) => {
      const tokens = (card.dataset.filters || '').split(',').map((token) => token.trim().toLowerCase());
      const isVisible = filter === 'todos' || tokens.includes(filter);
      card.classList.toggle('is-hidden', !isVisible);
      if (isVisible) visibleCount += 1;
    });

    if (this.emptyState) {
      this.emptyState.hidden = visibleCount > 0;
    }
  }
}

class SwEmAcaoLightbox {
  constructor() {
    this.dialog = document.getElementById('sw-em-acao-lightbox');
    if (!this.dialog) return;

    this.image = this.dialog.querySelector('[data-em-acao-lightbox-image]');
    this.panel = this.dialog.querySelector('[data-em-acao-lightbox-panel]');

    document.addEventListener('click', (event) => {
      if (event.target.closest('.sw-em-acao__card-badge')) return;

      const trigger = event.target.closest('[data-em-acao-open]');
      if (trigger) {
        event.preventDefault();
        this.open(trigger.closest('[data-em-acao-card]'));
        return;
      }

      if (event.target.closest('[data-em-acao-close]')) {
        this.close();
      }
    });

    this.dialog.addEventListener('close', () => {
      if (this.image) {
        this.image.removeAttribute('src');
        this.image.alt = '';
      }
      if (this.panel) {
        this.panel.innerHTML = '';
      }
    });

    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
  }

  open(card) {
    if (!card || !this.dialog || !this.image || !this.panel) return;

    const imageUrl = card.dataset.imageXl;
    const detail = card.querySelector('.sw-em-acao__card-body');
    if (!imageUrl || !detail) return;

    const cardImage = card.querySelector('.sw-em-acao__card-image');
    this.image.src = imageUrl;
    this.image.alt = cardImage?.alt || 'Foto Stoneway em Ação';
    this.panel.innerHTML = detail.innerHTML;

    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    }
  }

  close() {
    if (this.dialog?.open) {
      this.dialog.close();
    }
  }
}

if (!window.__swEmAcaoInit) {
  window.__swEmAcaoInit = true;
  customElements.define('sw-em-acao-filters', SwEmAcaoFilters);
  new SwEmAcaoLightbox();
}
